/* eslint-disable @typescript-eslint/no-explicit-any */

const opt = Object.prototype.toString;
const isArray = obj => {
  return opt.call(obj) === '[object Array]';
};
const isObject = obj => {
  return opt.call(obj) === '[object Object]';
};
const isString = obj => {
  return opt.call(obj) === '[object String]';
};
const isNumber = obj => {
  return opt.call(obj) === '[object Number]' && obj === obj; // eslint-disable-line
};

const isRegExp = obj => {
  return opt.call(obj) === '[object RegExp]';
};
const isUndefined = obj => {
  return obj === undefined;
};
const isFunction = obj => {
  return typeof obj === 'function';
};
const isEmptyObject = obj => {
  return isObject(obj) && Object.keys(obj).length === 0;
};
const isExist = obj => {
  return obj || obj === 0;
};
const isWindow = el => {
  return el === window;
};
const isDayjs = time => {
  return isObject(time) && ('$y' in time && '$M' in time && '$D' in time && '$d' in time && '$H' in time && '$m' in time && '$s' in time || time._isAMomentObject);
};
const isNull = value => {
  return value === null;
};
const isNil = value => {
  return isNull(value) || isUndefined(value);
};
const isNilOrEmpty = value => {
  return isNil(value) || value === '';
};
const isPromise = value => {
  return (value && Object.prototype.toString.call(value) === '[object Promise]') ?? false;
};

export { isArray, isDayjs, isEmptyObject, isExist, isFunction, isNil, isNilOrEmpty, isNull, isNumber, isObject, isPromise, isRegExp, isString, isUndefined, isWindow };
